import React, { useState, useEffect } from 'react'


export default function Question({ IsActioned, QIndex, SingleQuestionData, FormData, setFormData, setIsQuestionAnswered }) {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [questionType, setQuestionType] = useState('');
    const [characterCount, setCharacterCount] = useState(0);
    useEffect(() => {
        setFormData(prev => ({ ...prev, [QIndex]: { ...SingleQuestionData, answer: SingleQuestionData['answer_result'] } }))
        setQuestionType(SingleQuestionData?.is_mcq ? 'Multiple Choice' : 'Descriptive');
        setCharacterCount(SingleQuestionData['answer_result']?.length || 0);

        // if (!IsActioned && SingleQuestionData['answer_result'])
        //     setQindex(QIndex + 1)
    }, [SingleQuestionData['answer_result']])
    return (
        <>
            <div className="container-fluid">
                <div className="row mb-1">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Q{QIndex + 1}. {SingleQuestionData?.question}</h5>
                            <span className={`badge ${SingleQuestionData?.is_mcq ? 'badge-info' : 'badge-warning'}`}>
                                {questionType}
                            </span>
                        </div>
                        {SingleQuestionData?.question_image && (
                            <div className="mb-1">
                                <img
                                    src={SingleQuestionData.question_image}
                                    alt="Question Image"
                                    className="img-fluid rounded shadow-sm"
                                    style={{ maxHeight: '300px' }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {!SingleQuestionData?.is_mcq ?
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="descriptiveAnswer" className="form-label">
                                    <strong>Your Answer:</strong>
                                </label>
                                {/* {JSON.stringify(FormData[QIndex])}, */}
                                {FormData[QIndex]?.answer}
                                <textarea
                                    id="descriptiveAnswer"
                                    className='form-control'
                                    name='answer'
                                    rows="6"
                                    placeholder="Type your detailed answer here..."
                                    value={FormData[QIndex]?.answer || ''}
                                    onChange={e => {
                                        setIsQuestionAnswered(true);
                                        setFormData(prev => ({ ...prev, [QIndex]: { ...SingleQuestionData, answer: e.target.value } }));
                                        setCharacterCount(e.target.value.length);
                                    }}
                                    style={{ resize: 'vertical', minHeight: '120px' }}
                                />
                                <div className="d-flex justify-content-between mt-1">
                                    <small className="text-muted">Write a comprehensive answer</small>
                                    <small className={`${characterCount > 500 ? 'text-success' : characterCount > 200 ? 'text-warning' : 'text-muted'}`}>
                                        {characterCount} characters
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="row">
                        <div className="col-12 mb-1">
                            <label className="form-label"><strong>Choose the correct answer:</strong></label>
                        </div>
                        {/* {JSON.stringify(FormData)} */}
                        {/* {FormData[QIndex]?.answer} */}
                        {
                            FormData[QIndex]?.answer ? (
                                <div className="col-12 mb-1">
                                    <div className="alert alert-success">
                                        <strong>Your Last Answer:</strong> {FormData[QIndex]?.answer}
                                    </div>
                                </div>
                            ) : null
                        }
                        {['option1', 'option2', 'option3', 'option4'].map((optionKey, index) => (
                            SingleQuestionData?.[optionKey] && (
                                <div key={optionKey} className="col-md-6 mb-1" onClick={() => setIsQuestionAnswered(true)}>
                                    <div className={`form-check p-3 border rounded ${FormData[QIndex]?.answer === optionKey ? 'bg-light border-primary' : 'border-light'}`}
                                        style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                        onClick={() => setFormData(prev => ({ ...prev, [QIndex]: { ...SingleQuestionData, answer: optionKey } }))}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            id={`${optionKey}_${QIndex}`}
                                            name={`answer_${QIndex}`}
                                            checked={FormData[QIndex]?.answer === optionKey ? true : false}
                                            value={optionKey}
                                            onChange={() => {
                                                setIsQuestionAnswered(true);
                                                setFormData(prev => ({ ...prev, [QIndex]: { ...SingleQuestionData, answer: optionKey } }));
                                            }}
                                            onClick={() => setIsQuestionAnswered(true)}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={`${optionKey}_${QIndex}`}>
                                            <strong>{String.fromCharCode(65 + index)}.</strong> {SingleQuestionData?.[optionKey]}
                                        </label>
                                    </div>
                                </div>
                            )
                        ))}

                        {/* Clear Selection Button */}
                        {FormData[QIndex]?.answer && (
                            <div className="col-12 mt-2">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => setFormData(prev => ({ ...prev, [QIndex]: { ...SingleQuestionData, answer: '' } }))}
                                >
                                    🗑️ Clear Selection
                                </button>
                            </div>
                        )}
                    </div>
                }
            </div>
        </>
    )
}
